
import React, { JSX } from 'react'

const BUTTON_STYLE: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 10,
  height: 40,
  padding: '0 12px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #747775',
  borderRadius: 20,
  color: '#1F1F1F',
  fontSize: 14,
  fontWeight: 500,
  fontVariationSettings: "'wght' 400",
  fontFamily: 'Roboto, arial, sans-serif',
  cursor: 'pointer',
  whiteSpace: 'nowrap'
}

const GoogleGLogo = (): JSX.Element => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 48 48'
    aria-hidden='true'
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path
      fill='#4285F4'
      d='M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z'
    />
    <path
      fill='#34A853'
      d='M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z'
    />
    <path
      fill='#FBBC05'
      d='M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z'
    />
    <path
      fill='#EA4335'
      d='M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z'
    />
  </svg>
)

export const GoogleSignInButton = ({
  label = 'Continue with Google',
  onClick,
  disabled = false,
  busy = false,
  busyLabel = 'Opening Google…',
  'data-testid': testId
}: {
  label?: string
  onClick: () => void
  disabled?: boolean
  busy?: boolean
  busyLabel?: string
  'data-testid'?: string
}): JSX.Element => {
  const isDisabled = disabled || busy
  return (
    <button
      type='button'
      onClick={onClick}
      disabled={isDisabled}
      data-testid={testId}
      className='transition-colors hover:bg-[#F8F9FA] disabled:cursor-not-allowed disabled:opacity-60'
      style={BUTTON_STYLE}
    >
      <GoogleGLogo />
      <span>{busy ? busyLabel : label}</span>
    </button>
  )
}
